import { TripParamsProps } from 'src/common/api/request';
import { EstimateResponseProps, SeatProps, TripProps } from 'src/common/api/response';
import { create } from 'zustand';
import { PassengerInfoProps, PassengerSeatInfoProps, PassengerSeatProps, PassengerSeatsProps } from './TripInfoState';

interface SearchStateProps {
  searchInfo: TripParamsProps | undefined;
  setSearchInfo: (searchInfo: TripParamsProps) => void;
  changeDepartureDate: (date: Date) => void;
  changeReturnDate: (date: Date) => void;
  clearSearchInfo: () => void;

  departureTripInfo: TripProps | undefined;
  setDepartureTripInfo: (tripInfo: TripProps) => void;
  clearDepartureTripInfo: () => void;

  returnTripInfo: TripProps | undefined;
  setReturnTripInfo: (tripInfo: TripProps) => void;
  clearReturnTripInfo: () => void;

  passengerInfo: PassengerSeatsProps;
  setDepartureSeatsSelected: (seats: SeatProps[]) => void;
  clearDepartureSeatsSelected: () => void;
  setReturnSeatsSelected: (seats: SeatProps[]) => void;
  clearReturnSeatsSelected: () => void;
  setPassengerInfo: (passengerInfo: PassengerInfoProps) => void;
  clearPassengerInfo: () => void;

  passengerSeatInfo: PassengerSeatInfoProps;
  setDepartureSeatsInfoSelected: (seats: PassengerSeatProps[]) => void;
  clearDepartureSeatsInfoSelected: () => void;
  setReturnSeatsInfoSelected: (seats: PassengerSeatProps[]) => void;
  clearReturnSeatsInfoSelected: () => void;
  setPassengeSeatInfo: (passengerInfo: PassengerSeatInfoProps) => void;
  clearPassengerSeatInfo: () => void;

  estimation: EstimateResponseProps | undefined;
  setEstimation: (data: EstimateResponseProps) => void;
  clearEstimation: () => void;

  departureSeatChannel: string | undefined;
  returnSeatChannel: string | undefined;
  setDepartureSeatChannel: (channel: string) => void;
  setReturnSeatChannel: (channel: string) => void;
  clearDepartureSeatChannel: () => void;
  clearReturnSeatChannel: () => void;
}

const isDummy = false;
// const isDummy = true;

export const useTripInfoState = create<SearchStateProps>(set => ({
  // isDummy
  searchInfo: !isDummy
    ? undefined
    : {
        fromLocation: {
          abbreviation: 'btb',
          id: 'jYoD',
          name: 'Phnom Penh',
          slug: 'phnom-penh',
        },
        toLocation: {
          abbreviation: 'prv',
          id: '7veD',
          name: 'Siem Reap',
          slug: 'siem-reap',
        },
        departureDate: new Date('2023-03-25'),
        // returnDate: new Date(),
        returnDate: null,
        passenger: 1,
        serviceSlug: 'bus',
      },
  departureTripInfo: !isDummy
    ? undefined
    : {
        departureDate: '',
        promotions: [],
        operator: {
          id: 0,
          image:
            'https://play-lh.googleusercontent.com/og96kpwKRtLZUXZWODknC69EpjkrZgfMZhW8-6cao83uvYJ_mvCSsfhNwoW6722Kugk',
          name: 'Nham24 Express',
          rating: 4.0,
        },
        amenities: [],

        departureTime: '07:30 AM',
        duration: '4h 30m',
        tripId: '1XSE',
        image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
        price: 10,
        seatsAvailability: 17,
        service: 'Bus',
        transit: 0,
        instantBooking: true,
        bookingNotice: '',
        isAvailable: false,
        notAvailableMessage: '',
      },
  returnTripInfo: !isDummy
    ? undefined
    : {
        departureDate: '',
        promotions: [],
        operator: {
          id: 0,
          image:
            'https://play-lh.googleusercontent.com/og96kpwKRtLZUXZWODknC69EpjkrZgfMZhW8-6cao83uvYJ_mvCSsfhNwoW6722Kugk',
          name: 'Nham24 Express',
          rating: 4.0,
        },
        amenities: [],

        departureTime: '07:30 AM',
        duration: '4h 30m',
        tripId: '1XSE',
        image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
        price: 10,
        seatsAvailability: 17,
        service: 'Bus',
        transit: 0,
        instantBooking: true,
        bookingNotice: '',
        isAvailable: false,
        notAvailableMessage: '',
      },
  passengerInfo: !isDummy
    ? {
        name: '',
        phonenumber: '',
        email: '',
        coupon: '',
        passengerDepartureSeats: [],
        passengerReturnSeats: [],
      }
    : {
        name: '',
        phonenumber: '',
        email: '',
        coupon: '',
        passengerDepartureSeats: [],
        passengerReturnSeats: [],
        // name: 'hello',
        // phonenumber: '+85510628192',
        // email: 'hello@gmail.com',
        // coupon: '',
        // passengerDepartureSeats: [
        //   {
        //     availability: 'availabile',
        //     label: '09',
        //     seatId: '1SG1',
        //     type: 'twin-seat',
        //     nationality: {
        //       value: 'KH',
        //       label: 'Cambodia',
        //     },
        //     gender: {
        //       label: 'Male',
        //       value: 'male',
        //     },
        //   },
        //   {
        //     availability: 'availabile',
        //     label: '12',
        //     seatId: '1SG4',
        //     type: 'back-seat',
        //     nationality: {
        //       value: 'KH',
        //       label: 'Cambodia',
        //     },
        //     gender: {
        //       label: 'Male',
        //       value: 'male',
        //     },
        //   },
        // ],
        // passengerReturnSeats: [
        //   {
        //     availability: 'availabile',
        //     label: '09',
        //     seatId: '1SG1',
        //     type: 'twin-seat',
        //     nationality: {
        //       value: 'KH',
        //       label: 'Cambodia',
        //     },
        //     gender: {
        //       label: 'Male',
        //       value: 'male',
        //     },
        //   },
        //   {
        //     availability: 'availabile',
        //     label: '12',
        //     seatId: '1SG4',
        //     type: 'back-seat',
        //     nationality: {
        //       value: 'KH',
        //       label: 'Cambodia',
        //     },
        //     gender: {
        //       label: 'Male',
        //       value: 'male',
        //     },
        //   },
        // ],
      },
  // searchInfo: undefined,
  setSearchInfo: searchInfo => set(() => ({ searchInfo })),
  changeDepartureDate: date =>
    set(state => {
      const res: SearchStateProps = {
        ...state,
        searchInfo: { ...state.searchInfo, departureDate: date } as TripParamsProps,
      };
      return res;
    }),
  changeReturnDate: date =>
    set(state => {
      const res: SearchStateProps = {
        ...state,
        searchInfo: { ...state.searchInfo, returnDate: date } as TripParamsProps,
      };
      return res;
    }),

  clearSearchInfo: () => set(state => ({ ...state, searchInfo: undefined })),

  // departureTripInfo: undefined,
  setDepartureTripInfo: departureTripInfo => set(state => ({ ...state, departureTripInfo })),
  clearDepartureTripInfo: () => set(state => ({ ...state, departureTripInfo: undefined })),

  // returnTripInfo: undefined,
  setReturnTripInfo: returnTripInfo => set(state => ({ ...state, returnTripInfo })),
  clearReturnTripInfo: () => set(state => ({ ...state, departureTripInfo: undefined })),

  // passengerInfo: {
  //   name: '',
  //   passengerDepartureSeats: [],
  //   passengerReturnSeats: [],
  //   phonenumber: '',
  //   coupon: '',
  //   email: '',
  // },
  setDepartureSeatsSelected: seatsSelected => {
    set(state => ({ ...state, passengerInfo: { ...state.passengerInfo, passengerDepartureSeats: seatsSelected } }));
  },
  clearDepartureSeatsSelected: () => {
    set(state => ({ ...state, passengerInfo: { ...state.passengerInfo, passengerDepartureSeats: [] } }));
  },

  setReturnSeatsSelected: seatsSelected =>
    set(state => ({ ...state, passengerInfo: { ...state.passengerInfo, passengerReturnSeats: seatsSelected } })),
  clearReturnSeatsSelected: () =>
    set(state => ({ ...state, passengerInfo: { ...state.passengerInfo, passengerReturnSeats: [] } })),
  setPassengerInfo: passengerInfo =>
    set(state => ({ ...state, passengerInfo: { ...state.passengerInfo, ...passengerInfo } })),
  clearPassengerInfo: () =>
    set(state => ({
      ...state,
      seatsSelected: {
        name: '',
        phonenumber: '',
        email: '',
        coupon: '',
        passengerDepartureSeatsInfo: [],
        passengerReturnSeatsInfo: [],
      },
    })),

  estimation: undefined,
  setEstimation: estimation => set(state => ({ ...state, estimation })),
  clearEstimation: () => set(state => ({ ...state, estimation: undefined })),

  departureSeatChannel: undefined,
  returnSeatChannel: undefined,
  setDepartureSeatChannel: channel => set(state => ({ ...state, departureSeatChannel: channel })),
  setReturnSeatChannel: channel => set(state => ({ ...state, returnSeatChannel: channel })),
  clearDepartureSeatChannel: () => set(state => ({ ...state, departureSeatChannel: undefined })),
  clearReturnSeatChannel: () => set(state => ({ ...state, returnSeatChannel: undefined })),

  passengerSeatInfo: {
    name: '',
    phonenumber: '',
    email: '',
    coupon: '',
    passengerDepartureSeatsInfo: [],
    passengerReturnSeatsInfo: [],
  },

  setDepartureSeatsInfoSelected: passengerSeatsInfo =>
    set(state => ({
      ...state,
      passengerSeatInfo: { ...state.passengerSeatInfo, passengerDepartureSeatsInfo: passengerSeatsInfo },
    })),
  clearDepartureSeatsInfoSelected: () =>
    set(state => ({ ...state, passengerSeatInfo: { ...state.passengerSeatInfo, passengerDepartureSeatsInfo: [] } })),
  setReturnSeatsInfoSelected: passengerSeatsInfo =>
    set(state => ({
      ...state,
      passengerSeatInfo: { ...state.passengerSeatInfo, passengerReturnSeatsInfo: passengerSeatsInfo },
    })),
  clearReturnSeatsInfoSelected: () =>
    set(state => ({ ...state, passengerSeatInfo: { ...state.passengerSeatInfo, passengerReturnSeatsInfo: [] } })),
  setPassengeSeatInfo: passengerSeatInfo =>
    set(state => ({ ...state, passengerSeatInfo: { ...state.passengerSeatInfo, ...passengerSeatInfo } })),
  clearPassengerSeatInfo: () =>
    set(state => ({
      ...state,
      passengerSeatInfo: {
        name: '',
        phonenumber: '',
        email: '',
        coupon: '',
        passengerDepartureSeatsInfo: [],
        passengerReturnSeatsInfo: [],
      },
    })),
}));

// if (__DEV__) useTripInfoState.subscribe(console.log);
